import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { getPaginationUrl } from '../../utils/constants/GetPaginationURL';

const initialState = {
  loading: false,
  resData: {
    data: [],
    meta: {},
  },
};

export const getSkillxDashboard = createAsyncThunk(
  'skillxSlice/getSkillxDashboard',
  async ({ fromDate, toDate,}) => {
    const res = await apiRequest({
      method: 'get',
      url: `analytics/assessment-counts?fromDate=${fromDate}&toDate=${toDate}&limit=no`,
    });
    return res;
  }
);

const skillxSlice = createSlice({
  name: 'skillxSlice',
  initialState,
  reducers: {
    clearSkillxDashboard: (state) => {
      state.resData = {
        data: [],
        meta: {},
      };
    },
  },
  extraReducers: (builder) => {
    //..................GETING DASHBOARD FOR SKILLX................
    builder.addCase(getSkillxDashboard.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getSkillxDashboard.fulfilled, (state, action) => {
      state.loading = false;
      state.resData = {
        data: action?.payload?.data || [],
        meta: action?.payload?.meta || {},
      };
    });
  },
});

export const { clearSkillxDashboard } = skillxSlice.actions;
export default skillxSlice.reducer;
